// Modals Context for Toggling Modals
// Usage and Implementation in the App Component and other components that need to display modals on the screen at a time or in a sequence of modals to be displayed.

import React, {createContext, useState} from 'react';
import {Modal} from "../utils/types/ui";

export const ModalsContext = createContext({
    modals: [] as Modal[], // Array of Modals to be displayed on the screen at a time
    setModals: (modals: Modal[]) => {
    },
} as any);

export const useModals = () => React.useContext(ModalsContext);

interface Props {
    children: React.ReactNode;
}

export const ModalsProvider = ({children}: Props) => {
    const [modals, setModals] = useState([] as Modal[]);
    const [showUpgradeModal, setShowUpgradeModal] = useState(false);

    return (
        <ModalsContext.Provider value={{
            modals,
            setModals,
            showUpgradeModal,
            setShowUpgradeModal
        }}>
            {children}
        </ModalsContext.Provider>
    );
};